export default __webpack_public_path__ + "static/try-ezyvet-support-group-0c9d88c0b2c9e549dfc7a0e8c8b80b52.png";